
const Handlebars = require('handlebars');
Handlebars.registerHelper('template:generate', function(doc, initialEnabled, detailOptions, fromWizard) {
  if (doc && doc.elements) {
    const ViewBuilder = require('civicsUtils/view_builder/view_builder');
    return new Handlebars.SafeString(ViewBuilder.getContent(doc, initialEnabled, detailOptions, fromWizard));
  }
});
